import { useEffect, useState } from 'react';

const useViewport = () => {
  const [viewport, setViewport] = useState({
    height: 0,
    isMobile: false,
    isAddonBreakRow: false,
    width: 0,
    isXl: false,
  });

  const handleResize = () => {
    const isMobile = window.innerWidth <= 991;
    const isAddonBreakRow = window.innerWidth <= 374;
    const isXl = window.innerWidth >= 1104;

    setViewport({
      height: window.innerHeight,
      isMobile,
      isXl,
      isAddonBreakRow,
      width: window.innerWidth,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return viewport;
};

export default useViewport;
